import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  MenuItem,
  Slide,
  Tooltip,
} from "@material-ui/core";
import {
  ValidatorForm,
  SelectValidator,
} from "react-material-ui-form-validator";

import { useForm } from "../../../hooks/useForm";

import {
  getTiposSolicitudes,
  postSolicitud,
  setSolicitud,
  setActiveStep,
  setShowForm,
  setPresupuestoSeleccionado,
  savePresupuesto,
  desetearRetomandoAppMobile,
} from "../../../actions/autorizaciones/Autorizaciones";

import Notes from "../UI/Notes";
import FormSolicitudPractica from "./FormSolicitudPractica";
import FormSolicitudDenunciaInternacion from "./FormSolicitudDenunciaInternacion";
import { NotasMenu } from "../gestionAuditoria/Menus/NotasMenu";
import {
  STEPPER_AUTORIZACIONES,
  TIPOS_AUTORIZACIONES,
} from "../../../utils/constants";
import { startAlerta } from "../../../actions/ui/alertas";
import { FormSolicitudPresupuesto } from "./FormSolicitudPresupuesto";
import moment from "moment";
import "moment/locale/es";
import FormSolicitudInternacionDomiciliaria from "./FormSolicitudInternacionDomiciliaria";
import FormSolicitudPracticasEnInternacion from "./FormSolicitudPracticasEnInternacion";
import { NotasMenuPresupuesto } from "../gestionPresupuestos/Menus/NotasMenuPresupuesto";
import ModalHistorialAllConsumos from "../../compartidos/historialConsumos/ModalHistorialAllConsumos";
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import FormSolicitudOxigeno from "./FormSolicitudOxigeno";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const AutorizacionesDetalleOrdenForm = ({ permisoIngresoInterDom }) => {
  const dispatch = useDispatch();

  const {
    presupuestoSeleccionado,
    afiliadoSeleccionado = {},
    solicitudSeleccionada = {},
    tiposSolicitudes = [],
  } = useSelector((state) => state.autorizaciones);
  const { idSeccional } = useSelector((state) => state.auth);

  const [haveChangeValues, setHaveChangeValues] = useState(false);
  const [showModalNotas, setShowModalNotas] = useState(false);
  const [showModalNotasPresupuesto, setShowModalNotasPresupuesto] = useState(false);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(false);
  const [openModalConsumos, setOpenModalConsumos] = useState(false);

  let solicitudDefault = {
    celular: "",
    conInternacion: false,
    estadosSolicitud: "",
    fecha: "",
    fechaIngreso: "",
    fechaPrescripcion: "",
    fechaProgramada: "",
    idAfiliado: "",
    idDiagnostico: "",
    idEstadoSolicitud: "",
    idSector: "",
    idSolicitud: "",
    idTipoSolicitud: "",
    // idTipoSolicitud: TIPOS_AUTORIZACIONES.PRACTICAS,
    idMotivoInternacion: "",
    idUsuario: "",
    motivoInternacion: "",
    telefono: "",
    tipoSolicitud: "",
    urgente: true,
    idSolicitudDenunciaInt: null
  };

  const [
    formValues,
    handleInputChange,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
  ] = useForm(
    !!solicitudSeleccionada ? solicitudSeleccionada : solicitudDefault
  );

  const {
    celular,
    conInternacion,
    fechaIngreso,
    fechaPrescripcion,
    fechaProgramada,
    idMotivoInternacion = "0",
    idSector,
    idSolicitud,
    idTipoSolicitud,
    telefono,
    idSolicitudDenunciaInt
  } = formValues;

  let presupuestoDefault = {
    // celular: "",
    conInternacion: false,
    // estadosSolicitudPresup: "",
    fecha: "",
    fechaVencimiento: moment().add(30, 'days'),
    fechaOrden: moment(),
    fechaCarga: moment(),
    fechaCirugia: moment(),
    fechaPrescripcion: "",
    fechaProgramada: "",
    idAfiliado: "",
    idDiagnostico: "",
    idEstadoSolicitud: "",
    idEstadoPresupuesto: "",
    idSector: "",
    idPresupuesto: "",
    idTipoSolicitud: "",
    cuitPrestador: "",
    valor: "",
    nombrePrestador: "",
    idPrestador: "",
    idCartillaPrestador: "",
    idEfectorFacturacion: "",
    idTipoPresupuesto: "",
    // idMotivoInternacion: "",
    idUsuario: "",
    // motivoInternacion: "",
    // telefono: "",
    tipoSolicitud: "",
    urgente: false,
  };

  const [
    formValuesPresup,
    // handleInputChangePresup
    ,
    ,
    setearValorPresup,
    ,
    ,
    ,
    ,
    setearVariosValoresPresup,
  ] = useForm(
    !!presupuestoSeleccionado ? presupuestoSeleccionado : presupuestoDefault
  );

  const {
    // celularPresup,
    conInternacion: conInternacionPresup,
    fechaPrescripcion: fechaPrescripcionPresup,
    fechaProgramada: fechaProgramadaPresup,
    // idMotivoInternacion = "0",
    idPrestador,
    idCartillaPrestador,
    idEfectorFacturacion,
    idPresupuesto,
    fechaVencimiento,
    valor,
    cuitPrestador,
    nombrePrestador,
    idTipoPresupuesto,
    idTipoSolicitud: idTipoSolicitudPresup,
    fechaOrden,
    fechaCarga,
    fechaCirugia,
    soloMateriales
    // telefono
  } = formValuesPresup;

  const practicaElegida = tiposSolicitudes.filter(
    (solicitud) => solicitud.idTipo === idTipoSolicitud
  )[0];

  useEffect(() => {
    dispatch(getTiposSolicitudes());
  }, [dispatch]);

  const onSubmitHandler = () => {
    dispatch(desetearRetomandoAppMobile());
    if (!haveChangeValues) {
      dispatch(setShowForm(false));
    } else {
      if ((idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION ||
        (idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS && conInternacion))
        && (Number(idMotivoInternacion) === 0 || !idMotivoInternacion)) {
        dispatch(startAlerta("Debe seleccionar un Motivo de internación.", "error"))
      } else {
        if (idTipoSolicitudPresup === TIPOS_AUTORIZACIONES.PRESUPUESTOS ||
          idTipoSolicitud === TIPOS_AUTORIZACIONES.PRESUPUESTOS) {
          if (cuitPrestador === '') {
            dispatch(startAlerta("Debe seleccionar un Prestador Existente o ingresar uno nuevo y validarlo.", "error"))
          } else {
            const data = {
              ...presupuestoSeleccionado,
              conInternacion: conInternacionPresup,
              fechaVencimiento,
              fechaPrescripcion: fechaPrescripcionPresup,
              fechaProgramada: fechaProgramadaPresup,
              valor,
              cuitPrestador,
              nombrePrestador,
              idAfiliado: afiliadoSeleccionado?.id_afiliado,
              idSeccional,
              idPresupuesto,
              idTipoSolicitud,
              idPrestador,
              idTipoPresupuesto,
              idCartillaPrestador,
              idEfectorFacturacion,
              fechaOrden,
              fechaCarga,
              fechaCirugia,
              soloMateriales
              // idMotivoInternacion:
              // !!idMotivoInternacion && Number(idMotivoInternacion) > 0
              // ? Number(idMotivoInternacion)
              // : null,
              // telefono,
            };
            dispatch(setPresupuestoSeleccionado(data));
            dispatch(savePresupuesto(data, setShowForm));
          }
        } else {
          const data = {
            ...solicitudSeleccionada,
            celular,
            conInternacion,
            fechaIngreso,
            fechaPrescripcion,
            fechaProgramada,
            idAfiliado: afiliadoSeleccionado?.id_afiliado,
            idSeccional,
            idSector,
            idSolicitud,
            idTipoSolicitud,
            idMotivoInternacion:
              !!idMotivoInternacion && Number(idMotivoInternacion) > 0
                ? Number(idMotivoInternacion)
                : null,
            telefono,
            idSolicitudDenunciaInt
          };
          dispatch(setSolicitud(data));
          dispatch(postSolicitud(data, setShowForm));
        }
      }
    }
  };

  // console.log("solic_seleccionada", solicitudSeleccionada);

  return (
    <React.Fragment>
      {openModalConsumos && (
        <ModalHistorialAllConsumos
          open={openModalConsumos}
          onClose={() => {
            setOpenModalConsumos(false);
          }}
          afiliado={afiliadoSeleccionado /*presupuestoSeleccionado?.afiliado || solicitudSeleccionada?.afiliado*/}
        />
      )}
      {showModalNotas && (
        <Dialog
          open={showModalNotas}
          onClose={() => setShowModalNotas(false)}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle>Notas</DialogTitle>
          <DialogContent>
            <NotasMenu showBotonAgregar={false} desdeIngresoSolicitud={true} />
          </DialogContent>
        </Dialog>
      )}
      {showModalNotasPresupuesto && (
        <Dialog
          open={showModalNotasPresupuesto}
          onClose={() => setShowModalNotasPresupuesto(false)}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle>Notas</DialogTitle>
          <DialogContent>
            <NotasMenuPresupuesto
              showBotonAgregar={false}
              desdeIngresoSolicitud={true}
              disabled={true} />
          </DialogContent>
        </Dialog>
      )}
      <ValidatorForm onSubmit={onSubmitHandler} style={{ margin: "1rem 3rem" }}>
        <Grid
          container
          spacing={2}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={6}>
            {Array.isArray(tiposSolicitudes) && tiposSolicitudes.length > 0 && (
              <SelectValidator
                fullWidth
                margin="normal"
                label="Tipo de Autorización"
                name="idTipoSolicitud"
                value={idTipoSolicitud ? idTipoSolicitud : idTipoSolicitudPresup}
                onChange={(e) => {
                  setearVariosValores(idTipoSolicitud && idTipoSolicitud !== TIPOS_AUTORIZACIONES.PRESUPUESTOS
                    ? {
                      ...solicitudDefault,
                      idTipoSolicitud: e.target.value,
                    }
                    : {
                      ...presupuestoDefault,
                      idTipoSolicitud: e.target.value,
                    }
                  );
                  setearVariosValoresPresup(
                    {
                      ...presupuestoDefault,
                      idTipoSolicitud: e.target.value,
                      idTipoPresupuesto: '',
                      nombrePrestador: '',
                      cuitPrestador: '',
                    }
                  );
                  setHaveChangeValues(true);
                }}
                validators={["required"]}
                errorMessages={["Este campo es requerido"]}
              >
                {!permisoIngresoInterDom
                  ?
                  tiposSolicitudes.filter(s => s.idTipo !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA
                    // && s.idTipo !== TIPOS_AUTORIZACIONES.LABORATORIO
                  ).map((tipoSolicitud) => (
                    <MenuItem
                      key={tipoSolicitud.idTipo}
                      value={tipoSolicitud.idTipo}
                    >
                      {tipoSolicitud.descripcionTipo}
                    </MenuItem>
                  ))
                  :
                  tiposSolicitudes
                    // .filter(s => s.idTipo !== TIPOS_AUTORIZACIONES.LABORATORIO)
                    .map((tipoSolicitud) => (
                      <MenuItem
                        key={tipoSolicitud.idTipo}
                        value={tipoSolicitud.idTipo}
                      >
                        {tipoSolicitud.descripcionTipo}
                      </MenuItem>
                    ))
                }
              </SelectValidator>
            )}
          </Grid>
          {(solicitudSeleccionada?.idSolicitud || presupuestoSeleccionado?.idPresupuesto) && (
            <Notes
              onClick={() => {
                solicitudSeleccionada?.idSolicitud ? setShowModalNotas(true) : setShowModalNotasPresupuesto(true);
              }}
            />
          )}
          {
            <Tooltip title="Consumos">
              <Button
                style={{ marginTop: 5, marginLeft: (solicitudSeleccionada?.idSolicitud || presupuestoSeleccionado?.idPresupuesto) ? -30 : 10 }}
                onClick={() => setOpenModalConsumos(true)}
              >
                <NoteAddIcon fontSize="large" />
              </Button>
            </Tooltip>
          }
        </Grid>
        {practicaElegida?.idTipo === TIPOS_AUTORIZACIONES.PRACTICAS && (
          <FormSolicitudPractica
            formValues={formValues}
            practicaElegida={practicaElegida}
            setHaveChangeValues={setHaveChangeValues}
            setearValor={setearValor}
            setearVariosValores={setearVariosValores}
            handleInputChange={handleInputChange}
            setFechaSeleccionada={setFechaSeleccionada}
          />
        )}
        {practicaElegida?.idTipo ===
          TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION && (
            <FormSolicitudDenunciaInternacion
              formValues={formValues}
              practicaElegida={practicaElegida}
              setHaveChangeValues={setHaveChangeValues}
              setearValor={setearValor}
              setearVariosValores={setearVariosValores}
              handleInputChange={handleInputChange}
            />
          )}
        {practicaElegida?.idTipo ===
          TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA && (
            <FormSolicitudInternacionDomiciliaria
              formValues={formValues}
              practicaElegida={practicaElegida}
              setHaveChangeValues={setHaveChangeValues}
              setearValor={setearValor}
              setearVariosValores={setearVariosValores}
              handleInputChange={handleInputChange}
            />
          )}
        {practicaElegida?.idTipo === TIPOS_AUTORIZACIONES.OXIGENO && (
          <FormSolicitudOxigeno
            formValues={formValues}
            practicaElegida={practicaElegida}
            setHaveChangeValues={setHaveChangeValues}
            setearValor={setearValor}
            setearVariosValores={setearVariosValores}
            handleInputChange={handleInputChange}
          />
        )}
        {(idTipoSolicitud === TIPOS_AUTORIZACIONES.PRESUPUESTOS || (!idTipoSolicitud &&
          idTipoSolicitudPresup === TIPOS_AUTORIZACIONES.PRESUPUESTOS)) && (
            <FormSolicitudPresupuesto
              formValues={formValuesPresup}
              practicaElegida={practicaElegida}
              setHaveChangeValues={setHaveChangeValues}
              setearValor={setearValorPresup}
              setearVariosValores={setearVariosValoresPresup}
            // handleInputChange={handleInputChangePresup}
            />
          )}
        {practicaElegida?.idTipo === TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION && (
          <FormSolicitudPracticasEnInternacion
            formValues={formValues}
            practicaElegida={practicaElegida}
            setHaveChangeValues={setHaveChangeValues}
            setearValor={setearValor}
            setearVariosValores={setearVariosValores}
            handleInputChange={handleInputChange}
            setFechaSeleccionada={setFechaSeleccionada}
          />
        )}
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "3rem" }}
            onClick={() => {
              dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DATOS_TITULAR));
            }}
          >
            Anterior
          </Button>
          <Button variant="contained" color="primary" type="submit" disabled={fechaSeleccionada}>
            Siguiente
          </Button>
        </div>
      </ValidatorForm>
    </React.Fragment>
  );
};
